import { OfferStateList } from '@zurich/api/contract';
import { isValueEmpty } from '@zurich/common/recoil';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const offerStateUtils = {
    ...createArrayUtils(OfferStateList, {
        unknownType: UnknownType.STRING,
        translationPrefix: 'contract:offerState',
        createDefaultValue: () => 'calculationState',
        // no translations yet for these
        excludeOptions: [
            'active',
            'paid',
            'applicationApprovalApproval',
            'applicationCompleted',
            'notConcluded',
            'correction',
        ],
    }),
    isPremiumUpdateAllowed,
    isELUAllowed,
    isAngebotCreationAllowed,
    isAngebotViewAllowed,
    canAdvanceToBindingOffer,
    canAdvanceToApplicationUnsigned,
    isReadOnlyState,
    toNumber,
};
export const offerStateOptionsUtils = createArrayUtils(OfferStateList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:offerStateFilterOptions',
    createDefaultValue: () => 'calculationState',
    // no translations yet for these
    excludeOptions: [
        'active',
        'paid',
        'applicationApprovalApproval',
        'applicationCompleted',
        'notConcluded',
        'correction',
        'unbindingOffer',
        'applicationApprovalApproved',
    ],
});
function isPremiumUpdateAllowed(state) {
    return state === 'calculationState' || state === 'concept';
}
function isELUAllowed(state) {
    return toNumber(state) <= toNumber('applicationUnsigned');
}
function isAngebotCreationAllowed(state) {
    return toNumber(state) < toNumber('bindingOffer');
}
function isAngebotViewAllowed(state) {
    return state === 'bindingOffer';
}
function canAdvanceToBindingOffer(state) {
    return toNumber(state) < toNumber('bindingOffer');
}
function canAdvanceToApplicationUnsigned(state) {
    return toNumber(state) < toNumber('applicationUnsigned');
}
function isReadOnlyState(state) {
    const readOnlyStates = [
        'applicationApprovalPending',
        'applicationApprovalDeclined',
        'applicationApprovalApproved',
        'policy',
    ];
    return state !== null && readOnlyStates.includes(state);
}
function toNumber(state) {
    switch (state) {
        case 'calculationState':
            return 0;
        case 'concept':
            return 10;
        case 'unbindingOffer':
            return 15;
        case 'alternativeOffer':
            return 17;
        case 'bindingOffer':
            return 20;
        case 'applicationUnsigned':
            return 30;
        case 'applicationSigned':
            return 40;
        case 'applicationApprovalPending':
            return 50;
        case 'applicationApprovalApproved':
            return 60;
        case 'applicationApprovalDeclined':
            return 60;
        case 'applicationApprovalDeclinedAndCounterOffer':
            return 70;
        case 'policingPending':
            return 100;
        case 'policy':
            return 105;
        case 'canceled':
            return 110;
        // TODO IS THIS CORRECT????
        case 'active':
            return 120;
        case 'paid':
            return 130;
        case 'notConcluded':
            return 135;
        default:
            throw new Error(`Invalid offer state: ${state}`);
    }
}
/**
 * Return true if it's not called form completness checks, the value is empty and offerState is unsigned
 * Return true if it is called from completness and the offer state is equal or greater signed
 * Return false otherwise
 * @param isWarning if this was called by completness (see completeness.ts)
 * @param offerState the current offerState
 * @param value the value that is checked if it is empty
 */
export const completnessWarningChecks = (isWarning, offerState, value) => {
    if (!isWarning) {
        return (offerStateUtils.toNumber(offerState) <
            offerStateUtils.toNumber('applicationSigned') &&
            (isValueEmpty(value) || value === ''));
    }
    return (offerStateUtils.toNumber(offerState) >=
        offerStateUtils.toNumber('applicationSigned'));
};
